import { render, staticRenderFns } from "./MyPuzzles.vue?vue&type=template&id=eb1b0b7c&scoped=true"
import script from "./MyPuzzles.vue?vue&type=script&lang=js"
export * from "./MyPuzzles.vue?vue&type=script&lang=js"
import style0 from "./MyPuzzles.vue?vue&type=style&index=0&id=eb1b0b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1b0b7c",
  null
  
)

export default component.exports